import { screenSizes } from './screenSizes';
const media = {
    up: (breakpoint) => {
        return `@media screen and (min-width: ${screenSizes[breakpoint].min}px)`;
    },
    down: (breakpoint) => {
        return `@media screen and (max-width: ${screenSizes[breakpoint].max}px)`;
    },
    between: (minScreenSize, maxScreenSize) => {
        const minWidth = `min-width: ${screenSizes[minScreenSize].min}px`;
        const maxWidth = `max-width: ${screenSizes[maxScreenSize].max}px`;
        return `@media screen and (${minWidth}) and (${maxWidth})`;
    },
};
export { media };
//# sourceMappingURL=media.js.map